import { fetchUserRole } from "../api/fetchUser";
import { UserRoleEnum } from "../enums/role";

export const checkRole = async (roleToCheck?: UserRoleEnum) => {
    const role = await fetchUserRole();
    if (role === roleToCheck) return;

    if (role === UserRoleEnum.GROUP_CONSULTANT && roleToCheck === UserRoleEnum.CONSULTANT) return;

    if (role === UserRoleEnum.CONSULTANT || role === UserRoleEnum.GROUP_CONSULTANT) {
        return window.location.href = "/dealership";
    }

    if (role === UserRoleEnum.MANAGER) {
        return window.location.href = "/fleet-manager";
    }

    if (role === UserRoleEnum.TOWER) {
        return window.location.href = "/control-tower";
    }

    if (role === UserRoleEnum.PARTNERSHIP) {
        return window.location.href = "/partnership";
    }
}

export const getPersona = async () => {
    const role = await fetchUserRole();
    return roleToPersonaMap[role as UserRoleEnum];
}

const roleToPersonaMap: Record<UserRoleEnum, string> = {
    [UserRoleEnum.MANAGER]: 'fleet-manager',
    [UserRoleEnum.TOWER]: 'control-tower',
    [UserRoleEnum.CONSULTANT]: 'dealership',
    [UserRoleEnum.GROUP_CONSULTANT]: 'dealership',
    [UserRoleEnum.PARTNERSHIP]: 'partnership',
};